import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchFeatureSettings } from '@office-start/feature-settings-service';
import { fetchIdentity } from '@office-start/identity-service';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
import { fetchConfigInternal } from '../fetchConfigInternal';
import { defaultPrefetchOptions } from '../models/defaultPrefetchOptions';
/**
 * Generic function which can be used to preload office-start's ReactQuery cache with configuration data.
 */
export function prefetchConfig(options) {
    return __awaiter(this, void 0, void 0, function () {
        var key, queryKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = options.key;
                    queryKey = [key];
                    /*
                    This is designed to be the first call for the specified queryKey, which results in a new React Query
                    cache entry. While loading, modules making additional requests with the same queryKey will see this
                    cache entry as loading and wait for this response to complete.
                    */
                    return [4 /*yield*/, queryCache.prefetchQuery(queryKey, function () {
                            var fetchDataPromisesObject = {
                                featureGatesPromise: fetchFeatureGates(),
                                featureSettingsPromise: fetchFeatureSettings(),
                                userEntitlementsPromise: fetchUserEntitlements(),
                                contextPromise: fetchOfficeComponentContext(),
                                identityPromise: fetchIdentity(),
                            };
                            return fetchConfigInternal(fetchDataPromisesObject, options);
                        }, defaultPrefetchOptions)];
                case 1:
                    /*
                    This is designed to be the first call for the specified queryKey, which results in a new React Query
                    cache entry. While loading, modules making additional requests with the same queryKey will see this
                    cache entry as loading and wait for this response to complete.
                    */
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=prefetchConfig.js.map